export enum Language {
  Swedish = "Swedish",
  English = "English",
}
